module.exports = __webpack_public_path__ + "img/04.b65e4fd2.png";